import { getTagManager } from '../api/tagManager';
export const getPersonsByFile = async ({ fileChecksum }, logger) => {
    return await getTagManager(`file/${fileChecksum}/persons`, {}, logger);
};
